import { createSvgIcon } from "@mui/material";

const DocumentDialogIcon = createSvgIcon(
  <svg viewBox="0 0 80 80" fill="none">
    <path
      d="M0 21.5335C0 9.75145 9.55126 0.200195 21.3333 0.200195H58.6667C70.4487 0.200195 80 9.75146 80 21.5335V58.8669C80 70.6489 70.4487 80.2002 58.6667 80.2002H21.3333C9.55126 80.2002 0 70.6489 0 58.8669V21.5335Z"
      fill="var(--subtle-surface-bg, #F6F8FA)"
    />
    <path
      d="M48.323 21.4224H32.7112C29.7657 21.4224 27.3779 23.8102 27.3779 26.7557V59.335C27.3779 62.2805 29.7657 64.6683 32.7112 64.6683H55.6121C58.5577 64.6683 60.9455 62.2805 60.9455 59.335V34.0448C60.9455 32.6304 60.3836 31.2738 59.3834 30.2736L52.0942 22.9845C51.094 21.9843 49.7375 21.4224 48.323 21.4224Z"
      fill="#E8EEF2"
    />
    <path
      d="M21.0546 56.0087V34.1845C21.0546 33.3254 21.751 32.6289 22.6101 32.6289C23.4692 32.6289 24.1657 33.3254 24.1657 34.1845V56.0087C24.1658 58.095 25.8571 59.7865 27.9435 59.7865H48.8788L48.9591 59.7882C49.7809 59.83 50.4343 60.5098 50.4343 61.342C50.4343 62.1741 49.7808 62.8536 48.9591 62.8954L48.8788 62.8976H27.9435C24.1389 62.8976 21.0547 59.8132 21.0546 56.0087Z"
      fill="#B4C8D3"
    />
    <path
      d="M45.1448 16.1312C45.7266 15.5361 46.669 15.507 47.2858 16.0518L47.3444 16.1061L57.8084 26.3357C58.4227 26.9362 58.4336 27.921 57.8331 28.5353C57.2326 29.1496 56.2478 29.161 55.6335 28.5605L45.1699 18.3309L45.114 18.2736C44.5553 17.6693 44.5631 16.7264 45.1448 16.1312Z"
      fill="#B4C8D3"
    />
    <path
      d="M55.7477 58.2886V28.9549C55.7477 28.5867 55.4492 28.2883 55.0811 28.2882H48.8623C46.7759 28.2882 45.0846 26.5968 45.0845 24.5104V18.4418C45.0845 18.0737 44.786 17.7753 44.4179 17.7752H28.0937C26.0073 17.7752 24.3159 19.4665 24.3159 21.553V26.7326C24.3158 27.5917 23.6194 28.2882 22.7603 28.2882C21.9012 28.2882 21.2048 27.5917 21.2048 26.7326V21.553C21.2048 17.7483 24.289 14.6641 28.0937 14.6641H44.4179C46.5042 14.6642 48.1957 16.3555 48.1957 18.4418V24.5104C48.1957 24.8786 48.4942 25.1771 48.8623 25.1771H55.0811C57.1674 25.1772 58.8589 26.8685 58.8589 28.9549V58.2886C58.8588 59.1476 58.1623 59.8441 57.3033 59.8442C56.4442 59.8442 55.7478 59.1477 55.7477 58.2886Z"
      fill="#B4C8D3"
    />
    <path
      d="M39.0353 32.5591L39.1151 32.5613C39.9371 32.6029 40.5908 33.2823 40.5908 34.1146C40.5908 34.9469 39.9371 35.6264 39.1151 35.668L39.0353 35.6702H29.5995C28.7404 35.6702 28.0439 34.9737 28.0439 34.1146C28.0439 33.2555 28.7404 32.5591 29.5995 32.5591H39.0353Z"
      fill="#B4C8D3"
    />
    <path
      d="M46.2572 39.2173C47.1163 39.2173 47.8128 39.9137 47.8128 40.7728C47.8128 41.632 47.1163 42.3284 46.2572 42.3284H29.5997C28.7406 42.3284 28.0441 41.632 28.0441 40.7728C28.0441 39.9137 28.7406 39.2173 29.5997 39.2173H46.2572Z"
      fill="#B4C8D3"
    />
    <path
      d="M46.2571 45.7251C47.1162 45.7251 47.8126 46.4215 47.8126 47.2807C47.8126 48.1398 47.1162 48.8362 46.2571 48.8362H29.5995C28.7404 48.8362 28.0439 48.1398 28.0439 47.2807C28.0439 46.4215 28.7404 45.7251 29.5995 45.7251H46.2571Z"
      fill="#B4C8D3"
    />
  </svg>,
  "DocumentDialogIcon"
);

export default DocumentDialogIcon;
